<script setup>
import { computed } from 'vue';
const props = defineProps({
  imageName: {
    type: String,
    default: '',
    required: true,
  },
  imageNameVariant: {
    type: String,
    default: '',
    required: false,
  },
  before: {
    type: Boolean,
    default: false,
    required: false,
  },
  after: {
    type: Boolean,
    default: false,
    required: false,
  },
  small: {
    type: Boolean,
    default: false,
    required: false,
  },
});

// eslint-disable-next-line no-undef
const baseUrl = publicPath + modulePath || import.meta.env.VITE_BASE_URL;
const imageBind = computed(() => `url(  ${baseUrl}${props.imageName})`);
const imageBindVariant = props.imageNameVariant ? computed(() => `url(${baseUrl}${props.imageNameVariant})`) : imageBind;
const imageSize = computed(() => (props.small ? '1.6rem' : '2.5rem'));
</script>

<template>
  <div
    class="icon-with-label"
    :class="{
      'icon-with-label--icon-before': before,
      'icon-with-label--icon-after': after,
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.icon-with-label {
  display: flex;
  align-items: center;

  &--icon-before,
  &--icon-after {
    &:before,
    &:after {
      flex-shrink: 0;
      content: '';
      width: v-bind(imageSize);
      height: v-bind(imageSize);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }

  &--icon-before {
    &:before {
      margin-right: 1rem;
      background-image: v-bind(imageBind);
    }
  }

  &--icon-after {
    &:after {
      margin-left: 1rem;
      background-image: v-bind(imageBind);
      color: #76bd70;
      fill: #76bd70;
    }
  }
}
</style>

<style lang="scss">
.icon-with-label {
  h6,
  .h6,
  h5,
  .h5,
  h4,
  .h4,
  h3,
  .h3,
  h2,
  .h2,
  h1,
  .h1 {
    margin-bottom: 0 !important;
  }
}

.button:hover {
  .icon-with-label--icon-before:before {
    background-image: v-bind(imageBindVariant);
  }
  .icon-with-label--icon-after:after {
    background-image: v-bind(imageBindVariant);
  }
}
</style>
